import { render, staticRenderFns } from "./EmployeeWorkforceOverview.vue?vue&type=template&id=5ae2f3fc&scoped=true&"
import script from "./EmployeeWorkforceOverview.vue?vue&type=script&lang=js&"
export * from "./EmployeeWorkforceOverview.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeWorkforceOverview.vue?vue&type=style&index=0&id=5ae2f3fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae2f3fc",
  null
  
)

export default component.exports